import { MessageCircle } from "lucide-react";
import { COMPANY_INFO } from "@/constants/nav";

export const WhatsAppButton = () => {
  return (
    <a
      href={COMPANY_INFO.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="Chat with RKG NATURALS on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/30 hover:bg-[#1fb355] transition-colors"
    >
      <MessageCircle className="h-7 w-7" strokeWidth={2} />
    </a>
  );
};
